<template>
  <v-dialog :value="value" persistent max-width="610" @click:outside="closeDialog()">
    <v-card color="fill" >
      <v-container>
        <v-card-title class="my-0 py-0 pt-0 ml-4 heading-6">
          <v-row justify="space-between" class="my-2">
            <v-col class="ma-0 pa-0" align="start">
              <div class="text-no-wrap">
                {{ config.label }}
              </div>
            </v-col>
            <v-col class="pa-0 ma-0 pr-4" align="end">
              <v-btn icon @click="closeDialog()">
                <v-icon dense>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-row dense class="px-2 py-2">
          <v-col cols="6" class="py-2 px-2">
            <v-menu
              v-model="datePicker"
              transition="scale-transition"
              offset-y
              :close-on-content-click="false"
              nudge-top="25"
              max-width="290px"
              min-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  v-on="!readOnly ? on : null"
                  :value="formattedDates"
                  :label="config.label"
                  :readonly="readOnly"
                  :rules="[isValidDateRange]"
                  outlined
                  prepend-inner-icon="mdi-calendar"
                  dense
                  background-color="#fff"
                  hide-details
                  validate-on-blur
                  :clearable="!readOnly"
                  @click="datePicker = true"
                  @click:clear="clearDates"
                  >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="dates"
                v-if="datePicker && !readOnly"
                :allowed-dates="allowedDates"
                :min="contractDate.start_dt || config.min"
                range
                show-current
                scrollable
                no-title>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6" class="py-2 px-2">
            <v-menu
              v-model="offerDatePicker"
              transition="scale-transition"
              offset-y
              :close-on-content-click="false"
              nudge-top="25"
              max-width="290px"
              min-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  v-on="!readOnly ? on : null"
                  :value="formattedOfferDates"
                  :readonly="readOnly"
                  :disabled="offerDisabled"
                  :rules="[isValidOfferDateRange]"
                  outlined
                  label="Perishable Offer Start/End"
                  prepend-inner-icon="mdi-calendar"
                  dense
                  background-color="#fff"
                  :clearable="!readOnly"
                  @click="offerDatePicker = true"
                  @click:clear="clearOfferDates"
                  ref="offerField">
                </v-text-field>
              </template>
              <v-date-picker
                v-model="offerDates"
                v-if="offerDatePicker && !readOnly"
                :min="contractDate.offer_start_date || config.min"
                :allowed-dates="allowedOfferDates"
                range
                show-current
                scrollable
                no-title>
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
// Third-Party Helpers
import { addMinutes } from 'date-fns'
export default {
  name: 'AdOfferDateModal',
  props: [
    'value',
    'config',
    'promo',
    'allowedDates',
    'isValidDateRange',
    'readOnly'
  ],
  data() {
    return {
        dates: [],
        offerDates: [],
        datePicker: false,
        offerDatePicker: false
    }
  },
  created () {
    if (this.promo.start_dt) this.dates[0] = this.promo.start_dt
    if (this.promo.end_dt) this.dates[1] = this.promo.end_dt
    if (this.promo.offer_start_date) this.offerDates[0] = this.promo.offer_start_date
    if (this.promo.offer_end_date) this.offerDates[1] = this.promo.offer_end_date
  },
  mounted() {
    if (this.offerDates.length === 2) {
      this.$nextTick(() => {
        this.$refs.offerField.focus()
        this.$refs.offerField.blur()
      })
    }
  },
  watch: {
    dates: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.$emit('updateDates', this.dates, this.offerDates)
          if (newValue[1] && !oldValue[1]) this.datePicker = false
        }
      }
    },
    offerDates: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.$emit('updateDates', this.dates, this.offerDates)
          if (newValue[1] && !oldValue[1]) this.offerDatePicker = false
        }
      }
    }
  },
  computed: {
    contractDate() {
      return { 
        start_dt: this.dates.length > 0 ? this.dates[0] : null,
        end_dt: this.dates.length === 2 ? this.dates[1] : null,
        offer_start_date: this.offerDates.length > 0 ? this.offerDates[0] : null,
        offer_end_date: this.offerDates.length === 2 ? this.offerDates[1] : null
      }
    },
    offerDisabled() {
      return this.dates.length < 2 || (this.offerDates.length === 0 && this.readOnly)
    },
    formattedDates() {
      return this.formatDates(this.dates)
    },
    formattedOfferDates() {
      return this.formatDates(this.offerDates)
    },
    allowedOfferDates() {
      return (this.offerDates.length === 0) ? this.isAllowedStartDate : this.isAllowedEndDate
    },
    isValidOfferDateRange() {
      return this.validateOfferDateRanges()
    }
  },
  methods: {
    formatDates(dates) {
      if (dates.length > 0) {
        const formattedDates = dates.map(date => {
          const [year, month, day] = date.split('-')
          return `${month}/${day}/${year}`
        })
        return formattedDates.join(' - ')
      }
      return null
    },
    clearDates() {
      this.dates = []
      this.offerDates = []
    },
    clearOfferDates() {
      this.offerDates = []
    },
    closeDialog() {
      this.$emit('closeDialog')
    },
    isAllowedStartDate (val) {
      const numericDay = this.getNumericDay(val)
      return numericDay === 0
    },
    isAllowedEndDate (val) {
      const numericDay = this.getNumericDay(val)
      return numericDay === 6
    },
    startOfDay (dateString) {
      const date = new Date(dateString)
      date.setHours(0, 0, 0, 0)
      return date
    },
    getNumericDay (value) {
      let date = new Date(value)
      date = addMinutes(date, date.getTimezoneOffset())
      return date.getDay()
    },
    validateOfferDateRanges () {
      if (this.dates.length < 2 || this.offerDates.length < 2) return true
      let valid = true
          const start = this.startOfDay(this.dates[0])
          const end = this.startOfDay(this.dates[1])
          const offerStart = this.startOfDay(this.offerDates[0])
          const offerEnd = this.startOfDay(this.offerDates[1])
          if (this.offerDates.length > 1) {
            const validRange = (offerStart <= start) && (offerEnd >= end)
            if (!validRange) {
              valid = 'Perishable Offer Dates must overlap the entire Promo Date range.'
            }
          }
      return valid
    },
  }
}
</script>